import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from "@angular/core";
import _ from "lodash";

import { HouseOrderGuestService } from "../house-order-guest.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { SwitchPageService } from "@root/router/component/order-detail-sidebar/switch-page.service";
import { ModalService } from "@root/router/index/modal.service";
import { NzDrawerRef, NzDrawerService } from "ng-zorro-antd/drawer";
import { NavigationStart, Router } from "@angular/router";
import { filter } from "rxjs";
import { OrderGuestSimilarComponent } from "../order-guest-similar/order-guest-similar.component";
import { MultiHouseCalendarService } from "@root/router/component/calendar/multi-house-calendar/multi-house-calendar.service";
import { ViewVoucherComponent } from "@root/component/view-voucher/view-voucher.component";
import { splitCountryCodeAndMobile } from "@root/util/util";

@Component({
  selector: "host-order-guest-detail",
  templateUrl: "./order-guest-detail.component.html",
  styleUrls: ["./order-guest-detail.component.scss"],
})
export class OrderGuestDetailComponent implements OnInit, OnDestroy {
  @Input() guestId = null;
  @Output() onModify = new EventEmitter();

  guestDetail = null;
  countryList = [];

  constructor(
    private guestService: HouseOrderGuestService,
    private t: TranslateService,
    private globalModal: ModalService,
    private modalService: NzModalService,
    private switchPageService: SwitchPageService,
    private calendarService: MultiHouseCalendarService,
    private localModalService: ModalService,
    private drawerRef: NzDrawerRef,
    private drawer: NzDrawerService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.getCountryList();
    this.getGuestDetail();

    this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe(() => this.drawerRef.close());
  }

  getGuestDetail() {
    const params = {
      page: 1,
      page_size: 1,
      client_id: this.guestId,
    };
    this.guestService.getGuestDetail(params).subscribe((res) => {
      const detail = res?.data.list?.[0];
      const [code, mobile] = splitCountryCodeAndMobile(detail?.phone);
      this.guestDetail = {
        ...detail,
        has_mobile: !!mobile,
      };
      console.log("guest detail: ", this.guestDetail);
    });
  }

  // format(data) {
  //   const consume = _.get(data, "consumer_info");
  //   if (
  //     consume.avg_night_price === 0 &&
  //     consume.avg_reservation_price === 0 &&
  //     consume.checkin_times === 0 &&
  //     consume.cumulative_consumer === 0 &&
  //     consume.total_nights === 0 &&
  //     !this.showItem(consume.first_checkin_time) &&
  //     !this.showItem(consume.last_checkin_time)
  //   ) {
  //     _.assign(data.consumer_info, {
  //       show: false,
  //     });
  //   } else {
  //     _.assign(data.consumer_info, {
  //       show: true,
  //     });
  //   }
  //   return data;
  // }

  getCountryList() {
    this.guestService.getCountryList().subscribe((res) => {
      if (res.error_code === 0) {
        this.countryList = _.get(res, "data");
      }
    });
  }

  // showItem(value) {
  //   return value === "" || value === null ? false : true;
  // }

  getCountryName(code) {
    return _.flatMap(this.countryList, "members").find((item) => item.alpha2 === code)?.name;

    // let notFind = true;
    // let item;
    // for (let i = 0; i < this.countryList.length && notFind; i++) {
    //   item = _.find(_.get(this.countryList[i], "members"), { alpha2: country });
    //   if (item) {
    //     notFind = false;
    //   }
    // }
    // return item ? item.name : null;
  }

  jumpBackToGuestList() {
    this.switchPageService.back();
    // this.switchPageService.deleteNodeAndUpdateCurrentNode(true);
    // this.hasModifyGuest = false;
  }

  // copyPhone() {
  //   this.phoneClipboard = new ClipboardJS(".phone-copy");
  //   this.phoneClipboard.on("success", (e) => {
  //     // 手机已复制
  //     const successText = this.t.syncGet("success.phone_copied");
  //     this.messageService.success(successText);
  //     this.firstCopy = false;
  //     // 防止3秒内多次点击复制
  //     setTimeout(() => {
  //       this.firstCopy = true;
  //       this.phoneClipboard.destroy();
  //       this.phoneClipboard = null;
  //     }, 3000);
  //   });
  // }

  // copyEmail() {
  //   this.emailClipboard = new ClipboardJS(".email-copy");
  //   this.emailClipboard.on("success", (e) => {
  //     // 邮箱已复制
  //     const successText = this.t.syncGet("success.email_copied");
  //     this.messageService.success(successText);
  //     this.firstCopy = false;
  //     // 防止3秒内多次点击复制
  //     setTimeout(() => {
  //       this.firstCopy = true;
  //       this.emailClipboard.destroy();
  //       this.emailClipboard = null;
  //     }, 3000);
  //   });
  // }

  // copyId() {
  //   this.idClipboard = new ClipboardJS(".id-copy");
  //   this.idClipboard.on("success", (e) => {
  //     // 证件号已复制
  //     const successText = this.t.syncGet("success.id_number_copied");
  //     this.messageService.success(successText);
  //     this.firstCopy = false;
  //     // 防止3秒内多次点击复制
  //     setTimeout(() => {
  //       this.firstCopy = true;
  //       this.idClipboard.destroy();
  //       this.idClipboard = null;
  //     }, 3000);
  //   });
  // }

  checkSimilarGuest() {
    // console.log("draw ref: ", this.drawerRef);

    this.drawer.create({
      nzTitle: this.t.t("order.similar_guest"),
      nzContent: OrderGuestSimilarComponent,
      nzWidth: this.drawerRef.nzWidth,
      nzMask: false,
      nzMaskClosable: false,
      nzContentParams: {
        guestId: this.guestId,
      },
    });
    // this.switchPageService.navigate(PageName.GuestSimilar, { id: this.guestId });

    /** @deprecated */
    // if (this.from !== "order") {
    //   this.switchPageService.createNewLianBiao({
    //     page: PAGES_NAME.GUEST_DETAIL,
    //     showBack: false,
    //     id: this.guestId,
    //   });
    // }
    // this.switchPageService.insertNodeAndUpdateCurrentNode({
    //   page: PAGES_NAME.GUEST_SIMILAR,
    //   id: this.guestId,
    //   showBack: true,
    // });
  }

  deleteGuest() {
    this.modalService.warning({
      // nzTitle: "确定删除吗？",
      nzTitle: this.t.syncGet("warning.confirm_to_delete"),
      nzOkText: this.t.syncGet("word.confirm"),
      nzCancelText: this.t.syncGet("word.cancel"),
      nzOnOk: () => this.queryDeleteGuest(),
    });
  }

  queryDeleteGuest() {
    this.guestService.deleteClient({ id: this.guestId }).subscribe((res) => {
      if (res.error_code === 0) {
        this.drawerRef.close();
        // this.switchPageService.back();
        // this.switchPageService.deleteNodeAndUpdateCurrentNode(true);
        this.calendarService.refresh();
      }
    });
  }

  closePannel() {
    this.drawerRef.close();

    // this.switchPageService.go(0);
    // this.calendarService.cancelSelectReservation();

    // this.switchPageService.destroyCurrentLianBiao();
  }

  modify() {
    _.assign(this.guestDetail, {
      id_type: _.get(this.guestDetail, "id_type") === "" ? null : _.get(this.guestDetail, "id_type"),
      comment: _.get(this.guestDetail, "client_comment.comment"),
    });
    console.log("guestDetail: ", this.guestDetail);

    const modal = this.localModalService.displayUpdateGuestModal(this.guestDetail);
    modal.afterClose.subscribe((res) => {
      if (res && res.type === "onSuccess") {
        // this.hasModifyGuest = true;
        this.getGuestDetail();
        this.calendarService.refresh();
        console.log("success");

        this.onModify.emit();
      }
    });
  }

  showCredentials(credentials) {
    // this.globalModal.displayImageMagnifier(url);
    // console.log('credentials: ', credentials);
    const list = credentials.map((c) => ({
      url: c?.urls?.large_url,
    }));
    this.modalService.create({
      nzTitle: this.t.t("word.credentials"),
      nzWidth: 715,
      nzFooter: null,
      nzContent: ViewVoucherComponent,
      nzComponentParams: {
        pictureList: list,
      },
    });
  }

  ngOnDestroy() {}
}
